import styled from 'styled-components'

export const Wrapper = styled.div`
  /* .accordions .accordion {
    --bs-accordion-border-color: #ffffff !important;
  }

  .accordion-item:first-of-type .accordion-button {
    background-color: var(--bs-card-bg) !important;
  }
  .card-cancling-hover {
    box-shadow: 0 0 20px #ffe7e7;
    border-color: #ffa7a7 !important;
  }
  .card-enabling-hover {
    box-shadow: 0 0 20px #c6ffc6;
    border-color: #8eff8e !important;
  }
  .card {
    transition: background-color 0.5s;
  }

  .card-upgrade-hover {
    box-shadow: 0 0 20px #ffe0b2;
    border-color: #ffa726 !important;
  }

  .card-downgrade-hover {
    box-shadow: 0 0 20px #b2ebf2;
    border-color: #00bcd4 !important;
  }
  .nav-pill-circle .nav-link {
    color: var(--gray-600);
  }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--second-color);
    background-color: #f8f8f8;
    border-color: var(--second-color);
  }
  .card-subsc {
    min-height: 750px;
  } */
  .p-carousel .p-carousel-indicators {
    padding: 12px;
  }
  .p-speeddial-button.p-button.p-button-icon-only {
    border-radius: 50% !important;
    width: 56px !important;
    height: 56px !important;
  }

  .p-carousel-content {
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    /* margin: 10% auto; */
    margin-top: 0;
    background-color: #ffebcd !important;

    /* max-height: 150px; */
    /* max-width: 350px; */
  }

  .custom-dropdown-toggle {
    font-weight: bold;
  }
`
